import { localize } from "@/i18n/translate";
import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { api, errorCode } from "@/lib/api";
import { useAuth } from "./AuthContext";
import { usePortal } from "./i18n";
import { AuthLayout } from "./AuthLayout";
import { ErrorNote, FormField, btnPrimary, inputCls } from "./ui";
export const ForcePassword = () => {
  const {
    reload,
    logout
  } = useAuth();
  const {
    p,
    errText
  } = usePortal();
  const [v, setV] = useState({
    current_password: "",
    new_password: "",
    repeat: ""
  });
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async e => {
    e.preventDefault();
    if (!v.current_password) return setErr(p.auth.err.passwordEmpty);
    if (v.new_password.length < 8) return setErr(p.auth.err.password);
    if (v.new_password !== v.repeat) return setErr(p.auth.err.password2);
    setBusy(true);
    setErr(null);
    try {
      await api.put("/portal/password", {
        current_password: v.current_password,
        new_password: v.new_password
      });
      await reload();
    } catch (ex) {
      setErr(errText(errorCode(ex)));
      setBusy(false);
    }
  };
  const input = (k, id, auto) => <input id={id} type="password" autoComplete={auto} value={v[k]} onChange={e => setV({
    ...v,
    [k]: e.target.value
  })} className={inputCls(false)} data-testid={`force-${k}-input`} />;
  return <AuthLayout>
      <div data-testid="force-password-screen">
        <KeyRound className="h-9 w-9 text-signal" aria-hidden="true" />
        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-[-0.03em] sm:text-4xl">{localize(p.force.title)}</h1>
        <p className="mt-4 leading-relaxed text-mute">{localize(p.force.text)}</p>
        <form onSubmit={submit} noValidate className="mt-10 space-y-6">
          <ErrorNote testId="force-error">{localize(err)}</ErrorNote>
          <FormField id="fp-current" label={p.force.current}>{localize(input("current_password", "fp-current", "current-password"))}</FormField>
          <FormField id="fp-new" label={p.profile.newPw} hint={p.auth.passwordHint}>{localize(input("new_password", "fp-new", "new-password"))}</FormField>
          <FormField id="fp-repeat" label={p.auth.password2}>{localize(input("repeat", "fp-repeat", "new-password"))}</FormField>
          <button type="submit" disabled={busy} className={`${btnPrimary} w-full`} data-testid="force-submit-btn">
            {localize(busy && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />)} {localize(p.force.submit)}
          </button>
        </form>
        <button type="button" onClick={logout} className="mt-6 text-sm text-mute underline-offset-4 hover:text-signal hover:underline" data-testid="force-logout-btn">{localize(p.logout)}</button>
      </div>
    </AuthLayout>;
};
